<template>
  <div class="content">
    <div class="HomeImg">
      <img src="../../../assets/images/famous/famousBanner.png" alt />
    </div>
    <div class="before">
      <div class="beforeImg">
        <img src="../../../assets/images/famous/signbefore.png" alt />
      </div>
      <div class="beforeText">
        <p class="text">你还是你，依旧是你</p>
      </div>
    </div>
    <div class="later">
      <div class="laterImg">
        <img src="../../../assets/images/famous/signlater.png" alt />
      </div>
      <div class="laterText">
        <p class="text">·个性化个人推荐主页</p>
        <p class="text">·最新动态发布</p>
        <p class="text">·多渠道作品推介及销售转化</p>
        <p class="text">·直播+电商等主流模式的曝光宣传</p>
        <p class="text">·垂直客户群及实力粉丝的覆盖</p>
        <p class="text">·专题营销活动支持及社群资源共享</p>
        <p class="text">·翡翠王朝优质客气群设计/雕刻订单推荐</p>
        <p class="text">·SEO站外搜索引擎个人站点搭建</p>
        <p class="text">·自媒体推广矩阵（微信公众号、百度、网易、腾讯、抖音等全媒体覆盖）</p>
      </div>
      <div class="laterFootImg">
        <img src="../../../assets/images/famous/background.png" alt />
      </div>
    </div>
    <div class="join">
      <div class="joinImg">
        <img src="../../../assets/images/famous/join.png" alt />
      </div>
      <div class="joinTab">
        <div class="tabItem" style="background:#0F5E48">
          <div class="tabItemText">开通店铺</div>
        </div>
        <div class="tabItem" style="background:#CC7E12">
          <div class="tabItemText">开启直播</div>
        </div>
        <div class="tabItem" style="background:#B1422E">
          <div class="tabItemText">新品发布</div>
        </div>
        <div class="tabItem" style="background:#AA773D">
          <div class="tabItemText">自主上货拍卖</div>
        </div>
        <div class="tabItem" style="background:#0F5E48">
          <div class="tabItemText">一口价集市货品上传</div>
        </div>
        <div class="tabItem" style="background:#C63532">
          <div class="tabItemText">营销活动</div>
        </div>
        <div class="tabItem" style="background:#CC7E12">
          <div class="tabItemText">个人主页推荐</div>
        </div>
        <div class="tabItem" style="background:#B1422E">
          <div class="tabItemText">百万翠友互动</div>
        </div>
      </div>
      <div class="joinText">
        <p class="text">你选择一直沉默下去</p>
        <p class="text">还是让金子的光芒更亮一点</p>
        <p class="text">点亮自己，让世界发现你</p>
      </div>
    </div>
    <div class="new">
      <div class="newImg">
        <img src="../../../assets/images/famous/new.png" alt />
      </div>
      <div class="newText">
        <p class="ColumnText">翡翠王朝“名家荟萃”专栏</p>
        <p class="joinText">期待您的加入</p>
      </div>
    </div>
    <div class="apply">
      <div class="applyImg">
        <img src="../../../assets/images/famous/apply.png" alt />
      </div>
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
.content {
  background: #36211f;
  .text {
    color: #e8d5b7;
    font-size: 0.19rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(232, 213, 183, 1);
    line-height: 0.27rem;
    letter-spacing: 7px;
  }
  .HomeImg {
    height: 3.33rem;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .before {
    .beforeImg {
      margin: 0.47rem 0 0.23rem 0;
      width: 100%;
      height: 0.35rem;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .beforeText {
      margin-bottom: 0.66rem;
    }
  }
  .later {
    .laterImg {
      width: 100%;
      height: 0.35rem;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .laterText {
      margin: 0.27rem 0.2rem 0.31rem 0.21rem;
      .text {
        line-height: 0.36rem;
        letter-spacing: 0;
      }
    }
    .laterFootImg {
      width: 100%;
      height: 0.61rem;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
  .join {
    .joinImg {
      width: 100%;
      height: 0.35rem;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .joinTab {
      width: 4.68rem;
      height: 2.47rem;
      margin: 0.39rem 0.15rem 0.47rem 0.17rem;
      background: rgba(81, 59, 48, 1);
      border-radius: 0.11rem;
      border: 0.01rem solid rgba(205, 167, 118, 1);
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      align-items: center;
      .tabItem {
        margin-left: 0.25rem;
        height: 0.45rem;
        border-radius: 0.33rem;
        .tabItemText {
          font-size: 0.19rem;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(255, 255, 255, 1);
          line-height: 0.45rem;
          padding: 0 0.14rem;
        }
      }
    }
    .joinText {
      .text {
        font-size: 0.19rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(232, 213, 183, 1);
        line-height: 0.35rem;
        letter-spacing: 0;
      }
    }
  }
  .new {
    .newImg {
      width: 100%;
      height: 4.87rem;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .newText {
      margin: 0.61rem 0 0.51rem 0;
      .ColumnText {
        font-family: PingFangSC-Regular, PingFang SC;
        color: #f6d377;
        font-size: 0.29rem;
        line-height: 0.37rem;
      }
      .joinText {
        font-size: 0.19rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #f6d377;
        line-height: 0.37rem;
      }
    }
  }
  .apply {
      padding-bottom: 0.38rem;
    .newImg {
      width: 100%;
      height: 4.87rem;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
}
</style>